export default "__VITE_ASSET__RbwDhCda__"